import { render, staticRenderFns } from "./KabLannyJaya.vue?vue&type=template&id=0848b05b"
import script from "./KabLannyJaya.vue?vue&type=script&lang=js"
export * from "./KabLannyJaya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports